module.exports = "data:text/csv;base64,TmFtZSxQaG9uZSxFbWFpbCxKb2IgQ2FwYWNpdHksVGl0bGUsUm9sZSxDb21wYW55CmhlbGxvLDEyMzQ1Njc4OTAsdGVzdEB0ZXN0LmNvbSxhYWEsdHR0dHQscnJycnIsY2NjY2MK"


//////////////////
// WEBPACK FOOTER
// ./src/assets/files/contact_import_template.csv
// module id = 4IzL
// module chunks = 1